import ReagreeWaiver from './ReagreeWaiver'

export default ReagreeWaiver
